/** @format */

import React from 'react';
import './styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faHandshake } from '@fortawesome/free-solid-svg-icons';

// eslint-disable-next-line no-unused-vars
export default function LeadServiceContentV2({ text, mainImage, children }) {
  return (
    <div className='lead-service-content-v2-wrapper'>
      <div className='heading-section'>
        <h2 className='gradient-text'>
          Buying and selling <br /> homes with the help of us
        </h2>
      </div>
      <div className='form-section'>
        <div className='form-content'>{children}</div>
        <div className='main-image-wrapper'>
          <img src={mainImage} alt='Main' className='main-image' />
        </div>
      </div>
      <div className='log-in-link-section'>
        <span>Login to view your saved home wishlists</span>
      </div>
      <div className='services-section'>
        <div className='heading-section'>
          <h2 className='gradient-text'>Services for you</h2>
        </div>
        <div className='service-cards-wrapper'>
          <div className='service-card'>
            <div className='title-section'>
              <FontAwesomeIcon
                icon={faHome}
                size='lg'
                className='service-icon'
              />
              <span>Buy Home</span>
            </div>
            <p>
              Get help fining the right home even one that isn&apos;t listed on
              hemnet
            </p>

            <span className='more-info'>More information</span>
          </div>
          <div className='service-card'>
            <div className='title-section'>
              <FontAwesomeIcon
                icon={faHandshake}
                size='lg'
                className='service-icon'
              />
              <span>Sell Home</span>
            </div>
            <p>
              We match you with a realtor and compare before an ad has even been
              advertised
            </p>

            <span className='more-info'>More information</span>
          </div>
        </div>
      </div>
    </div>
  );
}
